export var KrakenHistoryStatus;
(function (KrakenHistoryStatus) {
    KrakenHistoryStatus["CLOSED"] = "CLOSED";
    KrakenHistoryStatus["OPEN"] = "OPEN";
})(KrakenHistoryStatus || (KrakenHistoryStatus = {}));
//# sourceMappingURL=kraken-history-status.enum.js.map